import { ThirdPartyAnimationSizesType, ThirdPartyAnimationVariantType } from './variants';
export const getThirdPartyAnimationStyles = (animation) => {
    return {
        [ThirdPartyAnimationVariantType.PRIMARY]: {
            thirdPartyAnimationData: animation.primary,
        },
        [ThirdPartyAnimationVariantType.SECONDARY]: {
            thirdPartyAnimationData: animation.secondary,
        },
        [ThirdPartyAnimationVariantType.SECONDARY_INPUT]: {
            thirdPartyAnimationData: animation.secondary_input,
        },
        [ThirdPartyAnimationVariantType.TERTIARY]: {
            thirdPartyAnimationData: animation.tertiary,
        },
        [ThirdPartyAnimationVariantType.TERTIARY_ON_SURFACE]: {
            thirdPartyAnimationData: animation.tertiaryOnSurface,
        },
        [ThirdPartyAnimationVariantType.TERTIARY_TECH_ONLY]: {
            thirdPartyAnimationData: animation.tertiaryTechOnly,
        },
        [ThirdPartyAnimationVariantType.BUBBLE]: {
            thirdPartyAnimationData: animation.bubble,
        },
        [ThirdPartyAnimationVariantType.CONTACT_CENTER]: {
            thirdPartyAnimationData: animation.contactCenter,
        },
        [ThirdPartyAnimationVariantType.CHAT]: {
            thirdPartyAnimationData: animation.chat,
        },
    };
};
export const getThirdPartyAnimationSizeStyles = (FOUNDATIONS) => {
    return {
        [ThirdPartyAnimationSizesType.EXTRA_LARGE]: {
            width: FOUNDATIONS.size_loader_primary,
            height: FOUNDATIONS.size_loader_primary,
        },
        [ThirdPartyAnimationSizesType.LARGE]: {
            width: FOUNDATIONS.size_500,
            height: FOUNDATIONS.size_500,
        },
        [ThirdPartyAnimationSizesType.MEDIUM]: {
            width: FOUNDATIONS.size_400,
            height: FOUNDATIONS.size_400,
        },
        [ThirdPartyAnimationSizesType.SMALL]: {
            width: FOUNDATIONS.size_300,
            height: FOUNDATIONS.size_300,
        },
        [ThirdPartyAnimationSizesType.EXTRA_SMALL]: {
            width: FOUNDATIONS.size_250,
            height: FOUNDATIONS.size_250,
        },
    };
};
//# sourceMappingURL=styles.js.map